export default __webpack_public_path__ + "static/media/E_Elefante.9c4b92fd.svg";